// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-note_root__20-lR","label":"cart-note_label__3juJ0"};